import {
  InputField,
  SearchInput,
  SubmitButton,
  TextComponent,
} from "../../../../components";
import styles from "./MyTemplates.module.css";
import eventImg from "../../../../assets/eventImg.png";
import { Col, List, Row, Space } from "antd";
import useWindowDimensions from "../../../../hooks/useWindowDimensions";
import { useLocation, useNavigate } from "react-router-dom";
import { VscTrash } from "react-icons/vsc";
import { IoChevronForward, IoClose, IoShareSocial } from "react-icons/io5";
import memberImg from "../../../../assets/avatar.png";
import memberImg1 from "../../../../assets/avatar-1.png";
import memberImg2 from "../../../../assets/avatar-2.png";
import memberImg3 from "../../../../assets/avatar-3.png";
import memberImg4 from "../../../../assets/avatar-4.png";
import Modal from "../../../../components/modal/Modal";
import { useState } from "react";
import Dropdown from "../../../../components/dropdowns/Dropdown";
import myTemplate1 from "../../../../assets/staticImages/MyTemplate1.png";
import myTemplate2 from "../../../../assets/staticImages/MyTemplate2.png";
import myTemplate3 from "../../../../assets/staticImages/MyTemplate3.png";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PlanningTemplatesMiddleware } from "../../../../Store/Middlewares/PlanningTemplatesMiddleware";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
import dummyImg from "../../../../assets/dummy.jpg";
import moment from "moment";
import { IoIosShareAlt } from "react-icons/io";
import { MdDelete } from "react-icons/md";
import { roles } from "../../../../config/roles";
import Storage from "../../../../utills/AsyncStorage";
import { getPlanningTemplate } from "../../../../Store/Actions/PlanningTemplatesAction";
// const headerRow = {
//   firstCol: "Type",
//   secondCol: "Date Created",
//   thirdCol: "Actions",
// };

const guestsRows = [
  {
    title: "Engagement Ceremony",
    type: "Wedding",
    date: "09 Feb 2023",
    public: true,
    img: myTemplate1,
  },
  {
    title: "Cocktail Party",
    date: "09 Feb 2023",
    type: "Wedding",
    img: myTemplate2,
  },
  {
    title: "Reception Ceremony",
    date: "09 Feb 2023",
    type: "Wedding",
    img: myTemplate3,
  },
];

export const dummyMembers = [
  {
    id: 1,
    name: "Kurt Bates",
    image: memberImg,
    selected: false,
  },
  {
    id: 2,
    name: "Isabella Bates",
    image: memberImg2,
    selected: false,
  },
  {
    id: 3,
    name: "Kurt Bates",
    image: memberImg3,
    selected: false,
  },
  {
    id: 4,
    name: "Kurt Bates",
    image: memberImg1,
    selected: false,
  },
  {
    id: 5,
    name: "Kurt Bates",
    image: memberImg4,
    selected: false,
  },
  {
    id: 6,
    name: "Kurt Bates",
    image: memberImg3,
    selected: false,
  },
  {
    id: 7,
    name: "Kurt Bates",
    image: memberImg1,
    selected: false,
  },
];

export const TickSvg = (
  <svg
    className={styles.svgIcon}
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_i_58_2113)">
      <circle
        cx="22.8144"
        cy="22.7948"
        r="22.2284"
        fill="var(--primary-color)"
      />
    </g>
    <path
      d="M18.8263 27.352L30.5884 16.4141C30.9539 16.0742 31.4191 15.9043 31.9839 15.9043C32.5488 15.9043 33.0139 16.0742 33.3794 16.4141C33.7449 16.754 33.9277 17.1866 33.9277 17.7118C33.9277 18.2371 33.7449 18.6697 33.3794 19.0095L20.2218 31.2452C19.8231 31.6159 19.3579 31.8013 18.8263 31.8013C18.2947 31.8013 17.8295 31.6159 17.4308 31.2452L12.2475 26.4251C11.882 26.0852 11.6992 25.6526 11.6992 25.1274C11.6992 24.6021 11.882 24.1695 12.2475 23.8296C12.6129 23.4898 13.0781 23.3198 13.643 23.3198C14.2078 23.3198 14.673 23.4898 15.0385 23.8296L18.8263 27.352Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_i_58_2113"
        x="0.585938"
        y="0.566406"
        width="49.457"
        height="49.457"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="5" dy="5" />
        <feGaussianBlur stdDeviation="5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_58_2113"
        />
      </filter>
    </defs>
  </svg>
);

export const EmptySvg = (
  <svg
    className={styles.svgIcon}
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="16.8176"
      cy="17.2971"
      r="15.6887"
      fill="white"
      stroke="var(--primary-color)"
      stroke-width="1.5"
    />
  </svg>
);

const inputFields = [
  {
    label: "Title",
    type: "text",
    name: "title",
    placeholder: "Engagement Ceremony",
  },
  {
    label: "Event Type",
    type: "dropdown",
    name: "eventType",
    placeholder: "Party",
    options: [{ value: "Party", option: "Party" }],
  },
  {
    label: "Event List",
    type: "dropdown",
    name: "eventList",
    placeholder: "Wedding Party",
    options: [{ value: "Wedding Party", option: "Wedding Party" }],
  },
];

const TableHeader = ({ item }) => {
  return (
    <Row className={styles.listItemFirst}>
      <Col xs={24} lg={15}>
        <Row className={styles.itemGroup2First}>
          <Col lg={7} xl={6} className={styles.group2Col}>
            <TextComponent text={item.firstCol} />
          </Col>
          <Col lg={7} xl={6} className={styles.group2Col}>
            <TextComponent text={item.secondCol} />
          </Col>
          <Col lg={7} xl={6} className={styles.group2Col}>
            <TextComponent text={item.thirdCol} textClass={styles.guests} />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

const LeftGroup = ({ item }) => {
  return (
    <div className={styles.itemGroup1}>
      <img src={item?.vendor_image ? item?.vendor_image : dummyImg}></img>
      <div className={styles.textGroup}>
        <TextComponent
          text={item?.title ? item?.title : "--"}
          textClass={styles.eventTitle}
        />
        {item?.public && (
          <TextComponent text={"(Public)"} textClass={styles.status} />
        )}
      </div>
    </div>
  );
};

const RightGroup = ({
  item,
  setAddMembers,
  setCurrItem,
  setdltTemplate,
  settempId,
  state,
}) => {
  const navigate = useNavigate();

  const role = Storage.getERole("@role");
  return (
    <Row gutter={[0, 16]} className={styles.itemGroup2}>
      {/* <Col xs={24} sm={8} lg={7} xl={6} className={styles.group2Col}>
        <TextComponent text="Type" textClass={styles.infoTitle} />
        <TextComponent text={item?.event_type ? item?.event_type : "--"} />
      </Col> */}
      <Col xs={24} sm={8} lg={7} xl={6} className={styles.group2Col}>
        <TextComponent text="Date Created" textClass={styles.infoTitle} />
        <TextComponent
          text={`Date: ${
            item?.created_at
              ? moment(item?.created_at).format("MM-DD-YYYY")
              : "--"
          }`}
        />
      </Col>
      {state?.eventData?.id && role != roles.staff ? (
        <MdDelete
          className={styles.dltIcon}
          onClick={() => {
            setdltTemplate(true);
            settempId(item);
          }}
        />
      ) : (
        <Col xs={24} sm={8} lg={7} xl={6} className={styles.group2Col}>
          <TextComponent text="Actions" textClass={styles.infoTitle} />
          <Row gutter={8} justify={"center"} style={{ position: "relative" }}>
            <Col
              onClick={() => {
                setdltTemplate(true);
                settempId(item);
              }}
            >
              <div className={styles.iconBtn}>
                <VscTrash />
              </div>
            </Col>
            {/* <Col>
          <div
            className={styles.iconBtn}
            onClick={(e) => {
              e.stopPropagation();
              setAddMembers(true);
              setCurrItem(item);
            }}
          >
            <IoShareSocial />
          </div>
        </Col> */}
            {/* <IoChevronForward className={styles.rightIcon} /> */}
          </Row>
        </Col>
      )}
    </Row>
  );
};

const MyTemplates = () => {
  const [addMembers, setAddMembers] = useState(false);
  const [dltTemplate, setdltTemplate] = useState(false);
  const [currItem, setCurrItem] = useState(false);
  const [members, setMembers] = useState(dummyMembers);
  const [event, setEvent] = useState();
  const [title, setTitle] = useState("");
  const [addTemplate, setAddTemplate] = useState(false);
  const [tempId, settempId] = useState(null);
  const { width } = useWindowDimensions();
  const PlanningTemplates = useSelector(
    (state) => state?.PlanningTemplatesReducer?.PlanningTemplates,
  );
  const VendorEvents = useSelector(
    (state) => state?.PlanningTemplatesReducer?.VendorEvents,
  );
  const user = useSelector((state) => state.AuthReducer.user);
  const role = Storage.getERole("@role");
  const EventDetails = useSelector((state) => state.EventReducer.EventDetails);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();
  // console.log("state||||||||||||||||", state);

  // console.log("state>>>>>>>>>>>>", state);
  useEffect(() => {
    getTemplates();

    // dispatch(PlanningTemplatesMiddleware.getVendorEvents());
  }, []);

  // useEffect(() => {
  //   if (PlanningTemplates.length == 0) {
  //     navigate(-1)
  //   }
  // }, [PlanningTemplates]);

  const getTemplates = () => {
    dispatch(
      PlanningTemplatesMiddleware.getPlanningTemplates({
        event_id: state?.eventData?.id,
      }),
    );
  };

  const addPlanningTemplate = () => {
    if (!title) {
      dispatch(
        showAlert({
          type: "Error",
          message: "Enter Template Title!",
        }),
      );
      return;
    } else {
      setAddTemplate(false);
      let eventData = {
        title: title,
      };
      dispatch(PlanningTemplatesMiddleware.createPlanningTemplates(eventData))
        .then(() => setTitle(""))
        .catch((err) => {
          setTitle("");
          // console.log(err);
        });
    }
  };
  const shareTemplate = () => {
    dispatch(
      PlanningTemplatesMiddleware.shareTemplate({
        id: currItem?.id,
      }),
    )
      .then(() => {
        setAddMembers(false);
      })
      .catch(() => {});
  };
  const selectMembers = (id) => {
    setMembers((prev) =>
      prev.map((member) => {
        if (member.id === id) {
          return { ...member, selected: !member.selected };
        } else {
          return member;
        }
      }),
    );
  };
  const deleteTemplate = () => {
    let eventData = {
      event_id: state?.eventData?.id,
      planning_template_id: tempId?.id,
    };
    dispatch(PlanningTemplatesMiddleware.deAssociatePlanningTemplate(eventData))
      .then(() => {
        // let data = [...PlanningTemplates]
        // let index = data.findIndex((item) => item?.id == tempId?.id)
        // data.splice(index, 1)
        getTemplates();

        // setTemplates(data)
      })
      .catch();
  };

  const deletePlaningForm = () => {
    dispatch(
      PlanningTemplatesMiddleware.deletePlanningTemplate({ id: tempId?.id }),
    )
      .then(() => {
        let data = [...PlanningTemplates];
        let index = data.findIndex((item) => item?.id == tempId?.id);
        data.splice(index, 1);
        dispatch(getPlanningTemplate(data));
      })
      .catch();
  };

  return (
    <>
      <Row
        className={styles.headingRow}
        justify={"space-between"}
        align={"middle"}
        gutter={[0, 8]}
      >
        <Col xs={24} md={9}>
          <TextComponent textClass={styles.templateHeading}>
            {`Planning Forms(${PlanningTemplates?.length})`}
          </TextComponent>
        </Col>
        {!state?.screenType && role == roles.vendor ? (
          <Col xs={12} md={15} lg={10}>
            <SubmitButton
              title="Add Planning Forms"
              onClick={() => {
                if (!user?.is_subscribed) {
                  dispatch(
                    showAlert({
                      type: "Error",
                      message: "Please subscribe to add template",
                    }),
                  );
                  navigate("/membership");
                } else {
                  setAddTemplate(true);
                }
              }}
            />
          </Col>
        ) : null}
      </Row>
      {PlanningTemplates?.length > 0 && (
        <List
          // header={<TableHeader item={headerRow} />}
          className={styles.list}
          itemLayout={width > 991 ? "horizontal" : "vertical"}
          dataSource={PlanningTemplates}
          renderItem={(item, index) => (
            console.log("planningform1", item),
            (
              <List.Item className={styles.listItem}>
                <Col
                  xs={24}
                  lg={9}
                  onClick={() =>
                    navigate(
                      state?.screenType == "event"
                        ? "/events/eventDetail/templates/section"
                        : "/templates/section",
                      {
                        state: {
                          headrTitle: "Planning Form",
                          publicTemplate: false,
                          item: item,
                          screenType: state?.screenType,
                          eventData: state?.eventData,
                        },
                      },
                    )
                  }
                >
                  <LeftGroup item={item} />
                </Col>
                <Col xs={24} lg={15}>
                  <RightGroup
                    item={item}
                    setAddMembers={setAddMembers}
                    setCurrItem={setCurrItem}
                    setdltTemplate={setdltTemplate}
                    settempId={settempId}
                    state={state}
                  />
                </Col>
              </List.Item>
            )
          )}
        />
      )}
      <Modal
        isModalOpen={addMembers}
        setIsModalOpen={setAddMembers}
        closable={true}
        className={styles.modal}
      >
        <div className={styles.modalCont}>
          <div className={styles.shareIcon}>
            <IoIosShareAlt />
          </div>
          <TextComponent
            text={`Do you want to share this template to ${
              currItem?.event_created_by ? currItem?.event_created_by : "client"
            } ?`}
            textClass={styles.modalHeading}
          />
          <SubmitButton
            title="Yes"
            btnClass={styles.modalBtnMembers}
            onClick={shareTemplate}
          />
        </div>
      </Modal>
      <Modal
        isModalOpen={dltTemplate}
        setIsModalOpen={setdltTemplate}
        closable={true}
        className={styles.modal}
      >
        <div className={styles.modalCont}>
          <div className={styles.shareIcon}>
            <MdDelete />
          </div>
          <TextComponent
            text={`Are you sure want to\n ${
              state?.eventData?.id ? "unlink" : "delete"
            } this template!`}
            textClass={styles.modalHeading}
          />
          <SubmitButton
            title="Yes"
            btnClass={styles.modalBtnMembers}
            onClick={() => {
              setdltTemplate(false);
              if (state?.eventData?.id) {
                deleteTemplate();
              } else {
                deletePlaningForm();
              }
            }}
          />
        </div>
      </Modal>
      <Modal
        isModalOpen={addTemplate}
        setIsModalOpen={setAddTemplate}
        closable={true}
        className={styles.modal}
      >
        <div className={styles.modalCon}>
          <TextComponent
            text={"Create Template"}
            textClass={styles.modalHeading}
          />
          <Space
            direction="vertical"
            size="small"
            style={{
              display: "flex",
              marginTop: "10px",
            }}
          >
            {/* <InputField
              label="Title"
              name="title"
              placeholder="Engagement Ceremony"
            />
            <Dropdown
              label="Event Type"
              name="eventType"
              placeholder="Party"
              options={[{ value: "Party", option: "Party" }]}
            /> */}
            {/* <Dropdown
              label="Event List"
              name="eventList"
              placeholder="Wedding Party"
              // options={[{ value: "Wedding Party", option: "Wedding Party" }]}
              object={VendorEvents}
              onChange={(e) => setEvent(e)}
            /> */}
            <InputField
              onChange={(e) => setTitle(e.target.value)}
              value={title}
              placeholder={"My Template"}
              label={"Title"}
            />
          </Space>
          <SubmitButton
            title="Add Template"
            btnClass={styles.modalBtnTemplate}
            onClick={addPlanningTemplate}
          />
        </div>
      </Modal>
    </>
  );
};

export default MyTemplates;
